import React from 'react'
import styled, { withTheme } from 'styled-components'

import { Icon, ColoredIcon } from '../../../../../src/ui/icons/Icon.jsx'
import { FlightLabel } from '../../../../../src/ui/labels/FlightLabel.jsx'
import ToolTipComponent from '../../../../../src/ui/tooltips/ToolTipComponent.jsx'

const Wrapper = styled.div`
  padding: 12px 12px 12px 12px;
  box-shadow: inset 0px -1px 0px #EBEBEB;
`

const TopItemsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`

const PoiIcon = styled.div`
  margin-right: 14px;
  width: 36px;
  height: 36px;

  &:lang(ar) { margin-right: 0px; margin-left: 14px; }
`

const CloseButton = styled.div`
  cursor: pointer;
`

const StatusWrapper = styled.div`
  margin-top: 8px;
  margin-bottom: 8px;
  margin-left: 50px;
  display: flex;
  align-items: center;
  ${({ theme }) => theme.fontSize('12px')};
  line-height: 18px;

  div {
    margin-left: 8px;
    color: ${({ theme }) => theme.colors.secondaryText};
  }
`

const PoiTitle = styled.div`
  ${({ theme }) => theme.fontSize('20px')};
  color: #333;
  font-weight: 500;
  line-height: 26px;
  flex: 1 1 auto;
`

const InvalidFlightInfo = withTheme(({
  theme,
  className,
  T,
  onCloseClicked
}) => {
  return <Wrapper className={className} data-cy='InvalidFlightInfo'>
    <TopItemsWrapper>
      <PoiIcon>
        <Icon id={'gate'} width={36} height={36} />
      </PoiIcon>
      <PoiTitle>
        {T('flightDetails:Flight Info Unavailable')}
      </PoiTitle>
      <ToolTipComponent tooltipText="Close" arrowPosition="left">
        <CloseButton onClick={e => {
          onCloseClicked()
        }} data-cy='CloseButton'>
          <ColoredIcon id="close" width={32} height={32} fillColor={theme.colors.secondary} />
        </CloseButton>
      </ToolTipComponent>
    </TopItemsWrapper>
    <StatusWrapper>
      <FlightLabel status={4} statusText={'Unavailable'} />
    </StatusWrapper>
  </Wrapper>
})

export default InvalidFlightInfo
